module.exports = __webpack_public_path__ + "static/media/down-arrow-white.78690c34.svg";